import { render } from "./aboutUs.vue?vue&type=template&id=692bc94d&scoped=true"
import script from "./aboutUs.vue?vue&type=script&lang=js"
export * from "./aboutUs.vue?vue&type=script&lang=js"

import "./aboutUs.vue?vue&type=style&index=0&id=692bc94d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-692bc94d"]])

export default __exports__